import { InputRadio, ListDescription } from '@alto/design-system';
import { PaymentMethodIcon } from '@alto/features';
import React from 'react';
import { getPaymentMethodIconName } from '~shared/features/payment-methods/helpers';
import formatPaymentMethod from '~shared/features/payment-methods/helpers/formatPaymentMethod';
import { type PaymentMethod } from '~shared/types/payment_methods';

type Props = {
  readonly paymentMethod: PaymentMethod;
  readonly value: string;
};

export const PaymentMethodRadioOption = ({ paymentMethod, value }: Props) => {
  const paymentText = formatPaymentMethod(paymentMethod);
  const paymentMethodIconName = getPaymentMethodIconName(paymentMethod);
  const { details } = paymentMethod;
  let expirationText = '';

  if (details?.card_expiration_month && details?.card_expiration_year) {
    const expirationMonth = details.card_expiration_month;
    const expirationYear = details.card_expiration_year;
    expirationText = `Expires ${expirationMonth}/${expirationYear}`;
  }

  return (
    <InputRadio
      radioPlacement="left"
      value={value}
      label={paymentText}
      descriptions={[<ListDescription key="expiration">{expirationText}</ListDescription>]}
      TitlePressableIcon={<PaymentMethodIcon paymentMethodIconName={paymentMethodIconName} />}
      titlePressableIconPlacement="right-aligned"
    />
  );
};
